import { gridViewConnectorFilterType } from '../../enums/gridViewConnectorFilterType';
import gvfUtils from '../../utils/gridViewFieldsUtils';
import { filterOperators } from '../../enums/filterOperators';

export default {
	methods: {
		gridItemConnectors(item) {
			if (!this.gridView) return [];
			if (!this.gridView.GridViewConnectors) return [];
			if (!this.gridView.GridViewConnectors.length > 0) return [];
			let connectors = [];
			this.gridView.GridViewConnectors.forEach((connector) => {
				if (this.isValidParentForConnector(item, connector)) {
					connectors.push(connector);
				}
			});
			return connectors;
		},

		isValidParentForConnector(item, connector) {
			let isValid = true;
			let filters = connector.GridViewConnectorFilters.filter(
				(x) =>
					x.GridViewConnectorFilterType ==
					gridViewConnectorFilterType.Parent
			);
			filters.forEach((filter) => {
				let validation = true;
				let key = this.getGridViewFieldKeyById(
					filter.FilterGridViewFieldId
				);
				if (!key) validation = false;
				switch (filter.FilterOperator) {
					case filterOperators.Equal:
						validation = item[key] && item[key] == filter.Value;
						break;
					case filterOperators.NotEqual:
						validation = item[key] && item[key] != filter.Value;
						break;
					case filterOperators.GreaterThan:
						validation = item[key] && item[key] > filter.Value;
						break;
					case filterOperators.GreaterOrEqualThan:
						validation = item[key] && item[key] >= filter.Value;
						break;
					case filterOperators.LowerThan:
						validation = item[key] && item[key] < filter.Value;
						break;
					case filterOperators.LowerOrEqualTahn:
						validation = item[key] && item[key] <= filter.Value;
						break;
					case filterOperators.Contains:
						validation =
							item[key] && item[key].includes(filter.Value);
						break;
					case filterOperators.StartsWith:
						validation =
							item[key] && item[key].startsWith(filter.Value);
						break;
					case filterOperators.IsBlank:
						validation = item[key] && item[key] == null;
						break;
					case filterOperators.IsNotBlank:
						validation = item[key] && item[key] != null;
						break;
					default:
						validation = false;
						break;
				}

				isValid = isValid && validation;
			});
			return isValid;
		},

		getGridViewFieldKeyById(columnId) {
			let gvf = this.gridView.Columns.find((x) => x.Id == columnId);
			if (!gvf) return null;
			return gvfUtils.getFieldName(gvf);
		},
	},
};
